import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/SphereGeometry'

export default meshComponent('Sphere', props, createGeometry)
